// removed by extract-text-webpack-plugin
module.exports = {"hover":"_4LH4I"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-hashtag.scss
// module id = 764
// module chunks = 3 4 5 6 7